import PropTypes from 'prop-types';
import React, { Fragment } from 'react';
import { AspectRatio, ContentLoader } from '@marvelapp/ui';
function CardLoader(_a) {
    var borderRadius = _a.borderRadius, ratio = _a.ratio;
    return (React.createElement(Fragment, null,
        React.createElement(ContentLoader, { borderRadius: borderRadius, mb: 32 },
            React.createElement(AspectRatio, { borderRadius: borderRadius, overflow: "hidden", ratio: ratio })),
        React.createElement(ContentLoader, { borderRadius: 6, height: 12, m: "0 auto", mb: 3, width: "60%" }),
        React.createElement(ContentLoader, { borderRadius: 6, height: 12, m: "0 auto", width: "80%" })));
}
CardLoader.propTypes = {
    borderRadius: PropTypes.any,
    ratio: PropTypes.any,
};
CardLoader.defaultProps = {
    borderRadius: 2,
};
export default CardLoader;
